module.exports = __webpack_public_path__ + "img/cu.09ad8327.svg";